import classNames from 'classnames'
import React from 'react'
import AbstractApp from './AbstractApp'
import AppMenu from './AppMenu'
import Filters from './filters/Filters'
import Footer from './Footer'
import MainProf from './main/MainProf'

class AppProf extends AbstractApp {
  get API_URL() {
    return './api/prof'
  }

  render() {
    const { print } = this.props
    const { filters, filter_descr, data } = this.state
    const { year_bounds } = data
    const series = this.getSeries()

    return (
      <div
        className={classNames({
          App: true,
          AppProf: true,
          print: print,
        })}
      >
        {print ? null : (
          <React.Fragment>
            <AppMenu current="prof" />
            <Filters
              filters={filters}
              filterDescr={filter_descr}
              makeDictUrl={this.makeDictUrl.bind(this)}
              onUpdate={this.applyFilterUpdater.bind(this)}
              isSingleSelect={{ prof: true }}
              yearBounds={year_bounds}
            />
          </React.Fragment>
        )}
        <MainProf
          filters={filters}
          series={series}
          print={print}
          data={data}
          onDrillDownProf={this.makeDrillDownHandler('prof')}
          hash={this.getHash()}
        />
        <Footer />
      </div>
    )
  }
}

export default AppProf



// WEBPACK FOOTER //
// ./src/AppProf.js